import React from "react"
import styled from "styled-components"
import { COLORS, IMAGES } from "../../constants"
import { P, SectionTitle } from "../../components"
import { darken } from "polished"
import { LazyImage } from "cn-react-helpers"
import { FaAndroid, FaApple } from "react-icons/fa"
const fetch = require(`node-fetch`)

export function News({ CITY, NEWSID }){

  const Top = styled(P)`
    color: ${COLORS.WHITE};
    text-align: center;
    margin-bottom: 60px;
  `


  const Content = styled.div`
    width: 100%;
    max-width: 900px;
    display: flex;
    position: relative;
    z-index: 10;
    margin: 0 auto;

    @media(max-width: 800px){
      flex-direction: column-reverse;
    }
  `

  const Description = styled.div`
    width: 100%;
    padding-top: 0px;
    text-align: center;

    @media(max-width: 800px){
      padding-top: 0px;
    }
  `

  const ContentNews = styled.div`
    width: 100%;
    padding-bottom: 50px;

    @media(max-width: 800px){
      padding-top: 0px;
    }
  `

  const Logo = styled(LazyImage)`
    width: 100%;
    max-width: 140px;
    margin:0 auto 10px auto;
    display: block;
    border-radius: 23px;
    background: white;
    border: solid white 2px;
    text-align: center;

    @media(max-width: 800px){
      max-width: 160px;
    }
  `

  const NewsImage = styled(LazyImage)`
    width: auto;
    max-width: 80%;
    max-height: 300px;
    margin-bottom: 30px;
    display: inline;
    border-radius: 23px;
    border: solid white 2px;

    @media(max-width: 800px){
      max-height: 200px;
    }
  `
  

  const Title = styled(SectionTitle)`
    margin-bottom: 0px;
    text-align: center;
    color: ${ CITY.COLOR };
    background: inherit;
    font-size: 120%;

    @media(max-width: 800px){
      text-align: center;
    }
  `

  const TitleNew = styled(SectionTitle)`
    text-align: left;
    color: ${darken(0.3, CITY.COLOR)};
    background: inherit;
    font-size: 160%;

    @media(max-width: 800px){
      text-align: center;
      font-size: 120%;
    }
  `
  const HourText = styled(SectionTitle)`
    text-align: left;
    color: ${ COLORS.FONT };
    font-size: 1.1em;
    margin-bottom: 0px;
    font-size: 110%;

    @media(max-width: 800px){
      text-align: center;
      font-size: 100%;
    }
  `

  const Text = styled(P)`
    color: ${COLORS.WHITE};

    @media(max-width: 800px){
      margin: 0 auto;
      max-width: 400px;
      text-align: center;
    }
  `
  // Download

  const Buttons = styled.div`
    width: 100%;
    max-width: 630px;
    margin: 0 auto;
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 20px;

    @media(max-width: 800px){
      max-width: 280px;
      grid-template-columns: 1fr;
    }
  `
  
  const DownloadButtonIcon = ({ icon }) => {
    const Icon = styled(icon)`
      font-size: 20px;
      color: ${COLORS};
      margin-right: 10px;
    `

    return <Icon />
  }

  const DownloadButton = styled.a`
    background-color: ${darken(0.1, CITY.COLOR)};
    font-size: 1.1em;
    padding: 5px;
    color: ${COLORS.WHITE};
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 3px;
    text-decoration: none;
    transition: all 0.3s linear 0s;

    &:hover{
      background-color: ${darken(0.2, CITY.COLOR)};
    }
  `

  const Block = styled.div`
    width: 100%;
    max-width: 500px;
    padding-bottom: 100px;
    margin: 0 auto 20px auto;

    @media(max-width: 800px){
      padding-bottom: 50px;
      margin: 0 auto 30px auto;
    }

    ${props => props.noSpace && css`
      padding-bottom: 0px;
      margin: 0 auto 0px auto;
      border-bottom: none;
    `}
  `

  const BlockText = styled(P)`
    text-align: center;
    color: ${COLORS.FONT};
    max-width: 500px;
    margin: 0 auto 20px auto;
    font-size: 100%;

    @media(max-width: 800px){
      max-width: 240px;
    }
  `
  // Dados
  const [error, setError] = React.useState(null);
  const [isLoaded, setIsLoaded] = React.useState(false);
  const [news, setNews] = React.useState(null);

  React.useEffect(() => {
    fetch(`${CITY.URLAPI}/noticias/${NEWSID}`)
      .then(res => res.json())
      .then(
        (result) => {
          setNews(result);
          setIsLoaded(true);
          console.log(result)
        },
        (error) => {
          setError(error);
          setIsLoaded(true);
        }
      )
  }, [])

  return (
    <>
        <Content> 
          <Description>
            <Logo
              loader={IMAGES.CITY_LOGO_LOADER}
              source={CITY.ICON} />
            <Title> {CITY.TITLE} </Title>
            <Text> {CITY.DESCRIPTION} </Text>
          </Description>
        </Content>
        <ContentNews>
          {isLoaded && !error ? <HourText> {news.created_at} </HourText> : null }
          <TitleNew> {!isLoaded ? "Carregando..." : ( error ?  "Desculpe. Não foi possivel carregar a noticia!" : news.titulo ) } </TitleNew>
          <Description>
            {isLoaded && !error && news.imagem? <NewsImage loader={IMAGES.CITY_LOGO_LOADER} source={news.imagem} /> : null }
          </Description>
          {isLoaded && !error ? <HourText dangerouslySetInnerHTML={{ __html: news.conteudo }}/> : null }
        </ContentNews>
    </>
  )
}

